// Packages Actions

import AvailabilityApiclient from '../../../api/clients/AvailabilityApiClient';
import ReservationsApiClient from '../../../api/clients/ReservationsApiClient';
import { HOWL_N_LEARN_CODE, LATE_CHECKOUT_PREFIXES, PACKAGE_TYPE } from '../../../utilities/constants';
import { getKidsUnderAge } from '../../../utilities/guestsUtils';
import packagesActionTypes from './packages.types';

const getAdjustmentPackage = selectedPackage => {
  if (selectedPackage.adjustmentCode && selectedPackage.adjustmentCode.length > 0) {
    return {
      packageCode: selectedPackage.adjustmentCode[0],
      quantity: selectedPackage.quantity,
      isAdjustment: true,
      parentPackageCode: selectedPackage.packageCode,
      packageType: selectedPackage.packageType
    };
  }
  return null;
};

function upsertToPackagesArray(packagesArray, obj) {
  let result = [...packagesArray];
  const index = result.findIndex(e => matchByPackageCode(e, obj));
  if (index === -1) {
    result.push(obj);
  } else {
    result[index] = obj;
  }
  return result;
}

function removeFromPackagesArray(packagesArray, obj) {
  return packagesArray.filter(pkg => {
    if (obj.isExtra) {
      return pkg.packageCode !== obj.packageCode || (pkg.packageCode === obj.packageCode && !pkg.isExtra);
    } else {
      return pkg.packageCode !== obj.packageCode;
    }
  });
}

function matchByPackageCode(e, params) {
  if (params.isExtra) {
    return e.packageCode === params.packageCode && e.isExtra;
  } else {
    return e.packageCode === params.packageCode && !e.isExtra;
  }
}

export const getPackageAvailability = params => dispatch => {
  dispatch({ type: packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_LOADING, isLoading: true });

  let apiClient = new AvailabilityApiclient('v2.2');
  const request = apiClient.getAvailabilityPackage(params);

  return request.then(
    response => {
      // This is needed for the pre check in flow
      const mappedData = response?.data?.packages.map(pck => {
        const OLD_TO_NEW_PACKAGE_TYPE = {
          'late-checkout': PACKAGE_TYPE.lateCheckOut
        };

        const type = pck.packageType[0].toLowerCase();

        return {
          ...pck,
          packageType: OLD_TO_NEW_PACKAGE_TYPE[type] || PACKAGE_TYPE[type]
        };
      });

      dispatch({
        type: packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_SUCCESS,
        packageAvailabilityList: mappedData,
        isLoading: false
      });

      dispatch({
        type: packagesActionTypes.SET_PACKAGES_PLAN_INFO_SUCCESS,
        planPackages: response.data.packageTable,
        isLoading: false
      });
    },
    err => {
      dispatch({
        type: packagesActionTypes.GET_PACKAGES_AVAILABILITY_INFO_ERROR,
        packageAvailabilityList: [],
        isLoading: false,
        requestFailed: true,
        errorMessage: `Oops, ${err.message}`
      });
    }
  );
};
/**
 * when non billable kid is added, check if selected package contains adjustment code, if available add the adjustment package to selected package list.
 */

export const upsertPackage = params => (dispatch, getState) => {
  const state = getState();
  let currentPackages = state.packages.selectedPackages;
  const kidsAgesList = state.guests.kidsAges;
  const nonBillableChildren = getKidsUnderAge(kidsAgesList, 4);

  let selectedPackages = upsertToPackagesArray(currentPackages, params);
  if (nonBillableChildren > 0) {
    const adjustmentPackage = getAdjustmentPackage(params);
    if (adjustmentPackage) {
      selectedPackages = upsertToPackagesArray(selectedPackages, adjustmentPackage);
    }
  }
  const learnPackage = selectedPackages.find(pckg => pckg.packageCode === HOWL_N_LEARN_CODE);
  if (learnPackage) {
    const lcoPackage = selectedPackages.find(selectedPackages =>
      selectedPackages.packageCode.includes(LATE_CHECKOUT_PREFIXES.code)
    );
    if (lcoPackage) {
      selectedPackages = removeFromPackagesArray(selectedPackages, lcoPackage);
    }
  }
  dispatch({
    type: packagesActionTypes.UPSERT_PACKAGES,
    selectedPackages: selectedPackages
  });
};
export const deletePackage = params => (dispatch, getState) => {
  let currentPackages = [...getState().packages.selectedPackages];
  const adjustmentPackages = currentPackages.filter(w => w.parentPackageCode === params.packageCode);
  if (adjustmentPackages.length > 0) {
    currentPackages = removeFromPackagesArray(currentPackages, adjustmentPackages[0]);
  }
  const remainingPackages = removeFromPackagesArray(currentPackages, params);
  dispatch({
    type: packagesActionTypes.DELETE_PACKAGES,
    selectedPackages: remainingPackages
  });
};
export const clearSelectedPackages = () => dispatch => {
  dispatch({
    type: packagesActionTypes.CLEAR_PACKAGES_SELECTED,
    selectedPackages: []
  });
};
export const clearPackagesByCodes = packagesCodes => (dispatch, getState) => {
  const currentPackages = getState().packages.selectedPackages;
  const selectedPackages = currentPackages.filter(
    selectedPackage => !packagesCodes.includes(selectedPackage.packageCode)
  );
  dispatch({
    type: packagesActionTypes.CLEAR_PACKAGES_BY_CODES,
    selectedPackages: selectedPackages
  });
};
export const clearPlanPackages = () => dispatch => {
  dispatch({
    type: packagesActionTypes.CLEAR_PACKAGES_PLAN,
    planPackages: [],
    selectedPackages: []
  });
};
export const getCabanas = ({ resId }) => async dispatch => {
  dispatch({ type: packagesActionTypes.GET_PACKAGES_CABANAS_AVAILABILITY_LOADING, isLoading: true });
  // V3
  const apiClient = new ReservationsApiClient('v3');
  const request = apiClient.fetchCabanasV3(resId);

  return request.then(
    response => {
      dispatch({
        type: packagesActionTypes.GET_PACKAGES_CABANAS_AVAILABILITY_SUCCESS,
        cabanasAvailabilityList: response.data,
        isLoading: false
      });
    },
    err => {
      dispatch({
        type: packagesActionTypes.GET_PACKAGES_CABANAS_AVAILABILITY_ERROR,
        cabanasAvailabilityList: [],
        isLoading: false,
        requestFailed: true,
        errorMessage: `Oops, ${err.message}`
      });
    }
  );
};
export const packagesImpressions = eventProps => dispatch => {
  dispatch({
    type: packagesActionTypes.GTM_PACKAGES_IMPRESSIONS,
    eventProps
  });
};
